import React, { Component, PropTypes } from 'react';
import './PasswordMeter.css';

class PasswordMeter extends Component {
  render() {
    let { score } = this.props;
    let meterClassNames = ['PasswordMeter'];
    let wrapperClassNames = ['PasswordMeterWrap'];

    if (this.props.isVisible) {
      wrapperClassNames.push('PasswordMeterWrap--visible');
    }

    if (this.props.lightVariant) {
      wrapperClassNames.push('PasswordMeterWrap--light');
    }

    let rankings = {
      0: 'zero',
      1: 'one',
      2: 'two',
      3: 'three',
      4: 'four'
    };

    let labels = {
      1: 'Poor',
      2: 'So-so',
      3: 'Good',
      4: 'Great!'
    };

    meterClassNames.push(`PasswordMeter--${rankings[score]}`);

    return (
      <div className={wrapperClassNames.join(' ')}>
        <div className={meterClassNames.join(' ')}>
        </div>
        <span className="PasswordMeter-label">
          {labels[score]}
        </span>
      </div>
    );
  }
}

PasswordMeter.propTypes = {
  score: PropTypes.number.isRequired,
  isVisible: PropTypes.bool.isRequired,
  lightVariant: PropTypes.bool
};

export default PasswordMeter;



// WEBPACK FOOTER //
// ./src/components/PasswordMeter.js